import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-flame" }
const _hoisted_2 = { class: "md-layout" }
const _hoisted_3 = { class: "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" }
const _hoisted_4 = { class: "confirm-modal-content confirm-modal-container__confirm-modal-content" }
const _hoisted_5 = { class: "confirm-modal-content__title" }
const _hoisted_6 = { class: "confirm-button-container" }
const _hoisted_7 = { class: "confirm-modal-content confirm-modal-container__confirm-modal-content" }
const _hoisted_8 = { class: "confirm-modal-content__title" }
const _hoisted_9 = { class: "confirm-button-container" }
const _hoisted_10 = { class: "page-title" }
const _hoisted_11 = { class: "control-page__header" }
const _hoisted_12 = { class: "recommend-display-dropdown-label" }
const _hoisted_13 = { class: "control-page__top-section top-section" }
const _hoisted_14 = { class: "top-section__filter" }

import Modal from '@/components/modal/Modal.vue';

import { reactive, provide, computed, onMounted, watch, h } from 'vue';
import { newDefaultData } from '@/appLogic/importData/initialData';
import { businessContentName } from '@/appLogic/business/businessTableHeaders';
import { ref } from 'vue';
import { i18n } from '@/i18n';
import { OnPreLoadedTableKey as onPreLoadedTableKey, onCheckIdsKey, openModalKey } from '@/injectStore/tableContent';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SimpleBusinessTableContent from '@/components/table/SimpleBusinessTableContent.vue';
import WorkDaysCalendarNotYetEnteredAlertModal from '@/components/modal/WorkDaysCalendarNotYetEnteredAlertModal.vue';
import { shouldShowWorkDaysCalendarNotEnteredAlertModal } from '@/appLogic/importData/calendar';
import ControlPageTab from '@/corePagesModule/components/ControlPageTab.vue';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { OrganizationBusinessRepository } from '@/businessRepository/organizationBusinessRepository';
import { BulkGetBusinessUseCase } from '@/businessUseCases/bulkGetBusinessUseCase';
import { BulkRegisterBusinessUseCase } from '@/businessUseCases/bulkRegisterBusinessUseCase';
import { ForecastStatusManager } from '@/appLogic/business/businessState';
import AddVariableTableContent from '@/corePagesModule/addVariableTableContent/pages/index.vue';
import {
  openConfirmModal,
  openFailToSavedModal,
  openOkInformationModal,
  openSuccessToSaveModal,
} from '@/corePagesModule/components/modal/modalActions';
import { useOrderControlStore } from '../orderControlStore';
import { storeToRefs } from 'pinia';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { NarrowState } from '@/corePagesModule/BaseTableContent/interface/uiState';
import { TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { UpdateOrderStatusUseCase } from '@/coreUseCasesModule/order/updateOrderStatusUseCase';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { useAggregateBusinessIdHasRecommendOrderStore } from '@/corePagesModule/store/useAggregateBusinessIdHasRecommendOrderStore';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { FilterContentItem, FilterModalItems } from '@/corePagesModule/filterModal/filterModal';
import { diContainer } from '@/coreContainer/container';
import { toast } from '@/corePagesModule/components/Toast/ToastManager';
import DisplayOrderListMenuDropDown from '@/orderControlModule/components/DisplayOrderListMenuDropDown.vue';
import { DisplayOrderListMenuItems } from '../entities/displayOrderListMenu';
import UpdateToApprovedMenuDropDown from '@/orderControlModule/components/UpdateToApprovedMenuDropDown.vue';
import { UpdateToApprovedMenuItems } from '../entities/updateToApprovedMenu';
import OrderStatusFilterButtons from './OrderStatusFilterButtons.vue';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import DropdownButton from '@/corePagesModule/components/DropdownButton.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';

/**
 * モーダルの種類を定義する
 */
type ModalType = 'edit' | 'forecast-detail' | 'sales-results' | 'register-from-copy' | 'eop-results' | 'order-form' | 'confirm-supplier';
interface IRegistrationTable {
  registrationModalState: boolean;
  editModalState: boolean;
  forecastDetailModalState: boolean;
  salesResultsModalState: boolean;
  orderFormModalState: boolean;
  confirmSupplierModalState: boolean;
  updateTable: boolean;
  formUseItem: IBusiness;
  checkedIds: string[];
  checkedBusinesses: IBusiness[];
  registerFromCopy: boolean;
  tableContentHeader: object;
  updateOrderStatusModalState: boolean;
  workDaysCalendarNotYetEnteredAlertModalStatus: boolean;
  addVariableContentModalState: boolean;
  getAggregateBusinessIdsHasRecommendOrderErrorModalState: boolean;
  isOpenDisplayOrderListMenuDropdown: boolean;
  selectedDisplayOrderListMenu: DisplayOrderListMenuItems | undefined;
}

// 変数

export default /*@__PURE__*/_defineComponent({
  __name: 'MainTable1',
  setup(__props) {

const organizationBusinessRepository = new OrganizationBusinessRepository();
const orderRepository = new OrderRepository();
const bulkGetBusinessUseCase = new BulkGetBusinessUseCase();
const bulkRegisterBusinessUseCase = new BulkRegisterBusinessUseCase();
const updateOrderStatusUseCase = new UpdateOrderStatusUseCase();

/**
 * 登録テーブルの状態を定義するインターフェース
 */
const orderControlStore = useOrderControlStore();
const { state: orderControlState } = storeToRefs(orderControlStore);
const {
  $reset,
  onChangePaging,
  sortTableContentItems,
  resetPagingOptions,
  fetchItems,
  onAppliedFilterModal,
  filterTableContentItems,
  fetchTableContentProperties,
  changeOrderStatusFilterItems,
  containsRecommendOrder,
  getFilterItemsValue,
  putHiddenRecommended,
} = orderControlStore;

const aggregateBusinessIdsHasRecommendOrderStore = useAggregateBusinessIdHasRecommendOrderStore();
const { state: aggregateBusinessIdsHasRecommendOrderState } = storeToRefs(aggregateBusinessIdsHasRecommendOrderStore);
const { fetchAggregateBusinessIdsHasRecommendOrder, fetchAggregateBusinessIdsHasApprovedRequestOrder } =
  aggregateBusinessIdsHasRecommendOrderStore;
const t = i18n.t;
const tableContent = ref(null);

let renderingKey = 0;
const isEditing = ref(false);
const isRefreshTable = ref(false);

// mounted
onMounted(async () => {
  await init();
  state.workDaysCalendarNotYetEnteredAlertModalStatus = await shouldShowWorkDaysCalendarNotEnteredAlertModal();
});

/**
 * 初期化処理
 */
const init = async () => {
  $reset();
  fetchItems();
  // 推奨情報を持つ集計ID一覧を取得する
  aggregateBusinessIdsHasRecommendOrderStore.$reset(); // 情報の初期化
  // fetchAggregateBusinessIdsHasRecommendOrder(orderControlState.value.filterModalItems);
  orderControlState.value.tableContentProperties = fetchTableContentProperties();

  renderingKey++;
};

/**
 * チェックされている全ての発注が承認依頼（ApprovalRequested）ステータスかどうかを判定
 */
const areAllCheckedItemsApprovalRequested = computed((): boolean => {
  const checkedItems = orderControlState.value.tableContentItems.filter((item) => state.checkedIds.includes(item.displayId));
  if (checkedItems.length === 0) {
    return false;
  }
  return checkedItems.every((item) => item.orderStatus === OrderStatus.ApprovalRequested);
});

const areAllCheckedItemsRecommended = computed(() => {
  const checkedItems = orderControlState.value.tableContentItems.filter((item) => state.checkedIds.includes(item.displayId));
  if (checkedItems.length === 0) return false;
  return checkedItems.every((item) => item.orderStatus === OrderStatus.Recommended);
});

// state変数
const state: IRegistrationTable = reactive<IRegistrationTable>({
  registrationModalState: false,
  editModalState: false,
  forecastDetailModalState: false,
  salesResultsModalState: false,
  orderFormModalState: false,
  confirmSupplierModalState: false,
  updateTable: false,
  formUseItem: newDefaultData,
  checkedIds: [],
  checkedBusinesses: [],
  registerFromCopy: false,
  tableContentHeader: businessContentName,
  updateOrderStatusModalState: false,
  workDaysCalendarNotYetEnteredAlertModalStatus: false,
  addVariableContentModalState: false,
  getAggregateBusinessIdsHasRecommendOrderErrorModalState: false,
  isOpenDisplayOrderListMenuDropdown: false,
  selectedDisplayOrderListMenu: undefined,
}) as IRegistrationTable;

// watcher
watch(
  () => aggregateBusinessIdsHasRecommendOrderState.value.loadingState.status.type,
  async () => {
    if (aggregateBusinessIdsHasRecommendOrderState.value.loadingState.status.type === 'error') {
      state.getAggregateBusinessIdsHasRecommendOrderErrorModalState = true;
    }
  }
);

// methods
/**
 * フィルターモーダルのアイテムを取得する処理
 */
const getFilterModalItems = (): FilterModalItems => ({ selectionFilterItems: getFilterItemsValue().value });

/**
 * チェックボックスの状態を更新する処理
 * @param checkIds - チェックされた行のID一覧
 */
const onCheck = async (checkIds: string[]) => {
  state.checkedIds = checkIds;
};

/**
 * ページ遷移を行う処理
 * TODO: 新IBusinessへの以降処理前でごちゃごちゃするのを避けるため、一旦旧IBusinessの型で置いている
 * 本当はstoreに括り出すべきでは？
 * @param event -  取引情報
 */
const sendRecommendOrderPageMethod = (event: string[]) => {
  const id = event ? event[0] : [];
  // 集計ID一覧をlocalStorageに保存しておく
  const result = diContainer.saveAggregateBusinessIdsForRecommendOrderUseCase.Execute(event);
  if (result.status.type === 'error') {
    toast.error(t('集計情報の保存に失敗しました'));
    return;
  }
  window.open(`#/business/recommend-order/list/${id}`, '_blank');
};

/**
 * モーダルを開く処理
 * @param event - 取引情報
 * @param type - モーダルの種類
 */
const openModal = (event: IBusiness, type: ModalType) => {
  state.formUseItem = Object.assign({}, JSON.parse(JSON.stringify(event)));

  switch (type) {
    case 'edit':
      state.editModalState = true;
      break;
    case 'forecast-detail':
      state.forecastDetailModalState = true;
      break;
    case 'sales-results':
      state.salesResultsModalState = true;
      break;
    case 'register-from-copy':
      // 既存商品の情報をもとに新規作成を行う
      state.registerFromCopy = true;
      state.registrationModalState = true;
      break;
    case 'order-form':
      state.orderFormModalState = true;
      break;
    case 'confirm-supplier':
      state.confirmSupplierModalState = true;
      break;
  }
};

/**
 * Excelインポートモーダルを閉じる処理
 */
const onComplete = () => {
  state.updateTable = true;
  state.checkedIds = [];
  (tableContent.value as any).clearCheckIds();
};

/**
 * チェックされた取引内容の情報をdbから取得
 * @returns チェックが付いている行の取引内容情報
 */
const getCheckedBusinesses = async (): Promise<IBusiness[]> => {
  const res = await bulkGetBusinessUseCase.Execute(organizationBusinessRepository, state.checkedIds);
  switch (res.status.type) {
    case 'success':
      return res.status.data;
    case 'error':
  }
  return [] as IBusiness[];
};
/**
 * 確認モーダルを非表示
 */
const closeModal = () => {
  onComplete();
  state.confirmSupplierModalState = false;
  state.updateOrderStatusModalState = false;
};

/**
 * 稼働日カレンダー未入力警告モーダルを非表示
 */
const closeWorkDaysCalendarNotYetEnteredAlertModal = () => {
  state.workDaysCalendarNotYetEnteredAlertModalStatus = false;
};
/**
 * 仕入先内示として確定させる取引を確定する
 */
const submitSupplierForecast = async () => {
  // 仕入先内示へ追加
  const updatedBusinesses: IBusiness[] = await ForecastStatusManager.addSuppliersForecast(await getCheckedBusinesses());
  updatedBusinesses.map((business) => (business.supplierAnnounce = business.customerAnnounce));
  const res = await bulkRegisterBusinessUseCase.Execute(organizationBusinessRepository, updatedBusinesses);
  switch (res.status.type) {
    case 'success':
      // ステータスの更新が完了したらモーダルを閉じる
      closeModal();
      break;
    case 'error':
    // TODO: implement
  }
};

/**
 * 確定発注ステータスを強制的に書き換える
 * 取引一覧に表示されているもので、確定発注を作成しない取引ステータスを「確定発注に作成しない」ステータスに変更する
 * TODO: 確定発注作成フローが完成次第forceUpdateOrderState()に変更する (現状、確定発注を作成する機構自体がないため、作成済みに倒すように置いてます)
 */
const forceUpdateConfirmOrder = async () => {
  // ステータス更新
  const updatedBusinesses = await ForecastStatusManager.addConfirmedOrder(await getCheckedBusinesses());
  // ステータス更新後の取引情報を登録
  const res = await bulkRegisterBusinessUseCase.Execute(organizationBusinessRepository, updatedBusinesses);
  switch (res.status.type) {
    case 'success':
      // ステータスの更新が完了したらモーダルを閉じる
      closeModal();
      break;
    case 'error':
    // TODO: implement
  }
};

/**
 * プロパティ追加モーダルを非表示
 */
const onSuccessSaveVariableContent = async () => {
  state.addVariableContentModalState = false;
  await openSuccessToSaveModal();
  // テーブルの再読み込み
  state.updateTable = true;
};

/**
 * プロパティ追加モーダルでの保存に失敗した場合の処理
 */
const onFailSaveVariableContent = async () => {
  state.addVariableContentModalState = false;
  await openFailToSavedModal();
};

/**
 * チェックがついている発注のorderStatusを承認済みに変更する
 */
const approveCheckedOrders = async () => {
  const modalResult = await openConfirmModal(
    'question',
    t('発注承認モーダル文', { number: state.checkedIds.length }),
    t('はい'),
    t('いいえ')
  );

  if (modalResult === undefined || modalResult.isConfirmed === false) {
    return;
  }

  orderControlState.value.updateOrderLoadingState.status.type = 'loading';

  // チェックされたdisplayIdをもとに取引情報から発注IDを取得する
  const checkedOrderIds = orderControlState.value.tableContentItems
    .filter((item) => state.checkedIds.includes(item.displayId))
    .map((item) => item.orderId)
    .filter((id) => id != null && id !== ''); // 推奨発注情報はorderIdが空文字なので、フィルターで弾いておく

  const updateOrderStatusResponse = await updateOrderStatusUseCase.Execute(
    orderRepository,
    checkedOrderIds,
    OrderStatus.ApprovedAwaitingDeliveryDate
  );
  switch (updateOrderStatusResponse.status.type) {
    case 'success':
      resetPagingOptions();
      await fetchItems();
      state.checkedIds = [];
      renderingKey++;
      orderControlState.value.updateOrderLoadingState.status.type = 'success';
      await openSuccessToSaveModal();
      return;
    case 'error':
      orderControlState.value.updateOrderLoadingState.status.type = 'error';
      openFailToSavedModal();
      return;
  }
};

/**
 * チェックがついている発注を削除する
 */
const deleteApprovalRequest = async () => {
  const modalResult = await openConfirmModal('question', t('承認依頼を削除しますか？'), t('はい'), t('いいえ'));

  if (modalResult === undefined || modalResult.isConfirmed === false) {
    return;
  }

  orderControlState.value.updateOrderLoadingState.status.type = 'loading';

  // チェックされたdisplayIdをもとに取引情報から発注IDを取得する
  const checkedOrderIds = orderControlState.value.tableContentItems
    .filter((item) => state.checkedIds.includes(item.displayId))
    .map((item) => item.orderId)
    .filter((id) => id != null && id !== ''); // 推奨発注情報はorderIdが空文字なので、フィルターで弾いておく

  const deleteOrderResponse = await diContainer.bulkDeleteOrderUseCase.Execute(checkedOrderIds);
  switch (deleteOrderResponse.status.type) {
    case 'success':
      resetPagingOptions();
      await fetchItems();
      state.checkedIds = [];
      renderingKey++;
      orderControlState.value.updateOrderLoadingState.status.type = 'success';
      await openSuccessToSaveModal();
      return;
    case 'error':
      orderControlState.value.updateOrderLoadingState.status.type = 'error';
      openFailToSavedModal();
      return;
  }
};

/**
 * 承認済に更新メニューが選択された際の処理
 * @param menuItem - 承認済に更新メニューの項目
 */
const onSelectedUpdateToApprovedMenu = async (menuItem: UpdateToApprovedMenuItems) => {
  if (menuItem === 'UpdateToApproved') {
    await approveCheckedOrders();
  } else if (menuItem === 'DeleteApprovalRequest') {
    await deleteApprovalRequest();
  }
};

/**
 * 推奨情報を持つ集計ID一覧を再取得する処理
 */
const reRunFetchAggregateBusinessIdsHasRecommendOrder = async () => {
  state.getAggregateBusinessIdsHasRecommendOrderErrorModalState = false; // エラーモーダルを閉じる
  await waitLoading(fetchAggregateBusinessIdsHasRecommendOrder(getFilterModalItems())); // 推奨情報を持つ集計ID一覧を再取得
};

/**
 * 発注一括確認メニューが選択された際の処理
 * @param displayOrderListMenu - 発注一括確認メニュー
 */
const onSelectedDisplayOrderListMenu = async (displayOrderListMenu: DisplayOrderListMenuItems) => {
  if (displayOrderListMenu === 'Recommend') {
    const targetIds = await fetchAggregateBusinessIdsHasRecommendOrder(getFilterModalItems());
    if (targetIds.length === 0) {
      await openOkInformationModal('info', t('推奨情報がありません'), 'OK');
      return;
    } else {
      sendRecommendOrderPageMethod(targetIds);
    }
  } else if (displayOrderListMenu === 'ApprovalRequested') {
    const targetIds = await fetchAggregateBusinessIdsHasApprovedRequestOrder(getFilterModalItems());
    if (targetIds.length === 0) {
      await openOkInformationModal('info', t('承認依頼情報がありません'), 'OK');
      return;
    } else {
      sendRecommendOrderPageMethod(targetIds);
    }
  }
};

/**
 * フィルターボタンを押した時の処理
 * @param filterItems - フィルター選択内容
 */
const filterAction = (filterItems: FilterContentItem[]) => {
  onAppliedFilterModal(filterItems);
  // NOTE: フィルターを適用した後に、推奨情報を持つ集計ID一覧を再取得する (orderControlState.value.filterModalItemsを使う)
  // fetchAggregateBusinessIdsHasRecommendOrder(orderControlState.value.filterModalItems);
};

/**
 * 推奨の表示非表示管理ボタンを押した際のハンドラ
 * @param optionValue - 選択したオプション
 */
const onClickRecommendDisplayOption = async (optionValue: string) => {
  switch (optionValue) {
    case 'hidden':
      await onClickHiddenRecommended();
      return;
    case 'reveal':
      $reset();
      orderControlState.value.isHiddenRecommendShow = true;
      fetchItems();
      renderingKey++;
      return;
  }
};

/**
 * 推奨を非表示にするボタンクリック
 */
const onClickHiddenRecommended = async () => {
  const confirm = await showInfoModal({
    modalTitle: t('選択した推奨を非表示にしますか？'),
    modalDescription: h('div', { style: { width: 'max-content', textAlign: 'start', margin: '0 auto' } }, [
      t('・選択した推奨発注を非表示にします'),
      h('br'),
      t('・非表示期間は6日間です'),
    ]),
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('OK'),
  });
  if (!confirm) return;
  const res = await waitLoading(putHiddenRecommended(state.checkedIds, true));
  if (res) {
    showInfoModal({ modalTitle: t('保存しました'), backButtonLabel: t('OK'), isDisabledNextButton: true });
    state.checkedIds = [];
    init();
  } else {
    showInfoModal({ modalTitle: t('保存に失敗しました'), backButtonLabel: t('OK'), isDisabledNextButton: true });
  }
};

/**
 * 非表示推奨表示から通常の画面に戻る
 */
const onClickBackToDefault = () => {
  $reset();
  fetchItems();
  renderingKey++;
};

/**
 * 推奨を再表示するボタンクリック
 */
const onClickRevealRecommended = async () => {
  const confirm = await showInfoModal({
    modalTitle: t('選択した推奨を再表示しますか？'),
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('OK'),
  });
  if (!confirm) return;
  const res = await waitLoading(putHiddenRecommended(state.checkedIds, false));
  if (res) {
    showInfoModal({ modalTitle: t('保存しました'), backButtonLabel: t('OK'), isDisabledNextButton: true });
    state.checkedIds = [];
    init();
  } else {
    showInfoModal({ modalTitle: t('保存に失敗しました'), backButtonLabel: t('OK'), isDisabledNextButton: true });
  }
};

provide(openModalKey, openModal);
provide(onCheckIdsKey, onCheck);
provide(onPreLoadedTableKey, () => {});
provide(onPreLoadedTableKey, () => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Modal, {
          class: "confirm-modal-container",
          "modal-size": '2xl',
          "aspect-ratio": true,
          "stretch-container": true,
          "scroll-off": true,
          padding: '16px',
          "modal-state": state.updateOrderStatusModalState,
          onOutsideClick: closeModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('発注ステータスを更新しますか？')), 1),
              _createVNode(SimpleBusinessTableContent, {
                class: "confirm-modal-content__table",
                "table-type": 'confirmSupplierTable',
                items: state.checkedBusinesses,
                "scroll-enable": true
              }, null, 8, ["items"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(TextButton, {
                  color: 'primary',
                  size: 'btn-md',
                  class: "confirm-button-container__confirm-button",
                  onClick: forceUpdateConfirmOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('はい')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(TextButton, {
                  color: 'default',
                  size: 'btn-md',
                  class: "confirm-button-container__confirm-button",
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('いいえ')), 1)
                  ], undefined, true),
                  _: 1
                })
              ])
            ])
          ], undefined, true),
          _: 1
        }, 8, ["modal-state"]),
        _createVNode(Modal, {
          class: "confirm-modal-container",
          "modal-size": '2xl',
          "aspect-ratio": true,
          "stretch-container": true,
          "scroll-off": true,
          padding: '16px',
          "modal-state": state.confirmSupplierModalState,
          onOutsideClick: closeModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('受領した内示を仕入先への内示としますか？')), 1),
              _createVNode(SimpleBusinessTableContent, {
                class: "confirm-modal-content__table",
                "table-type": 'confirmSupplierTable',
                items: state.checkedBusinesses,
                "scroll-enable": true
              }, null, 8, ["items"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(TextButton, {
                  color: 'primary',
                  size: 'btn-md',
                  class: "confirm-button-container__confirm-button",
                  onClick: submitSupplierForecast
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('はい')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(TextButton, {
                  color: 'default',
                  size: 'btn-md',
                  class: "confirm-button-container__confirm-button",
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('いいえ')), 1)
                  ], undefined, true),
                  _: 1
                })
              ])
            ])
          ], undefined, true),
          _: 1
        }, 8, ["modal-state"]),
        _createVNode(WorkDaysCalendarNotYetEnteredAlertModal, {
          "is-open-modal": state.workDaysCalendarNotYetEnteredAlertModalStatus,
          onOutsideClick: closeWorkDaysCalendarNotYetEnteredAlertModal
        }, null, 8, ["is-open-modal"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('管理表')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(ControlPageTab, { class: "control-page-tab" }),
            (_unref(orderControlState).isHiddenRecommendShow)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(TextButton, {
                    "button-style": "btn-primary",
                    size: "btn-sm",
                    disabled: !areAllCheckedItemsRecommended.value,
                    onClick: onClickRevealRecommended
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('選択した推奨発注を再表示する')), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(TextButton, {
                    "button-style": "btn-secondary",
                    size: "btn-sm",
                    onClick: onClickBackToDefault
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('元の画面に戻る')), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(OrderStatusFilterButtons, {
                    "filter-status": _unref(orderControlState).orderStatusFilterItems,
                    "record-count": _unref(orderControlState).summaryCount,
                    onUpdateOrderStatusFilter: _unref(changeOrderStatusFilterItems)
                  }, null, 8, ["filter-status", "record-count", "onUpdateOrderStatusFilter"]),
                  _createVNode(UpdateToApprovedMenuDropDown, {
                    class: "order-status-button__update-button",
                    disabled: 
                  state.checkedIds.length === 0 ||
                  (!_unref(orderControlState).orderStatusFilterItems.Recommended && _unref(containsRecommendOrder)(state.checkedIds)) ||
                  !areAllCheckedItemsApprovalRequested.value
                ,
                    onSelectedItem: _cache[0] || (_cache[0] = 
                  (item) => {
                    // 選択メニューの情報更新
                    onSelectedUpdateToApprovedMenu(item);
                  }
                )
                  }, null, 8, ["disabled"]),
                  _createVNode(DisplayOrderListMenuDropDown, {
                    class: "order-status-button__update-button",
                    "is-open-prop": state.isOpenDisplayOrderListMenuDropdown,
                    "selected-item-prop": state.selectedDisplayOrderListMenu,
                    "onClick:selectInput": _cache[1] || (_cache[1] = () => (state.isOpenDisplayOrderListMenuDropdown = true)),
                    onClose: _cache[2] || (_cache[2] = () => (state.isOpenDisplayOrderListMenuDropdown = false)),
                    onSelectedItem: _cache[3] || (_cache[3] = 
                  (item) => {
                    // 選択メニューの情報更新
                    onSelectedDisplayOrderListMenu(item);
                  }
                )
                  }, null, 8, ["is-open-prop", "selected-item-prop"]),
                  _createVNode(DropdownButton, {
                    options: [
                  { label: _unref(t)('推奨を非表示にする'), value: 'hidden', disabled: !areAllCheckedItemsRecommended.value },
                  { label: _unref(t)('非表示推奨の確認・再表示'), value: 'reveal' },
                ],
                    style: 'secondary',
                    size: "sm",
                    onClickOption: onClickRecommendDisplayOption
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(Mdi, {
                          icon: "visibility",
                          variant: "outlined"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('推奨の表示・非表示')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["options"])
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(FilterModalButton, {
                class: "top-section__filter",
                "filter-modal-type": "orderControl",
                "select-input-index": 0,
                "filter-items": _unref(getFilterItemsValue)().value,
                onApply: _cache[4] || (_cache[4] = (filteredContents) => filterAction(filteredContents))
              }, null, 8, ["filter-items"])
            ]),
            (_unref(orderControlState).pagingOptions)
              ? (_openBlock(), _createBlock(Pagination, {
                  key: 0,
                  "paging-options": _unref(orderControlState).pagingOptions,
                  "is-loading": _unref(orderControlState).loadingState.status.type === 'loading',
                  class: "pagination",
                  onOnChangePage: _cache[5] || (_cache[5] = ($event: any) => (_unref(onChangePaging)($event)))
                }, null, 8, ["paging-options", "is-loading"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(NewBaseTableContent, {
            key: _unref(renderingKey),
            "prop-table-content-properties": _unref(orderControlState).tableContentProperties,
            "prop-display-objects": _unref(orderControlState).tableContentItems,
            "prop-loading-status": _unref(orderControlState).loadingState,
            "prop-table-type": 'orderManageTable',
            "prop-is-editing": isEditing.value,
            "prop-is-reset": isRefreshTable.value,
            class: "unordered-items-table__contains unordered-items-table__contains--table",
            onChecked: _cache[6] || (_cache[6] = ($event: any) => (state.checkedIds = $event)),
            onOnClickSort: _cache[7] || (_cache[7] = (sortKey, isAsc) => _unref(sortTableContentItems)(sortKey, isAsc)),
            onOnClickFilter: _cache[8] || (_cache[8] = (narrowState) => _unref(filterTableContentItems)(narrowState)),
            onReload: init
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "prop-is-editing", "prop-is-reset"]))
        ]),
        _createVNode(Modal, {
          "stretch-container": true,
          "modal-title": "なんか入力して",
          "modal-size": "3xl",
          "modal-state": state.addVariableContentModalState,
          onOutsideClick: _cache[9] || (_cache[9] = ($event: any) => (state.addVariableContentModalState = false))
        }, {
          default: _withCtx(() => [
            _createVNode(AddVariableTableContent, {
              "table-type": 'baseTable',
              onOnSuccess: onSuccessSaveVariableContent,
              onOnError: onFailSaveVariableContent
            })
          ], undefined, true),
          _: 1
        }, 8, ["modal-state"])
      ])
    ]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(orderControlState).updateOrderLoadingState.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('データを保存しています')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": state.getAggregateBusinessIdsHasRecommendOrderErrorModalState,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('再実行'),
      icon: "error",
      "enable-outside-click": false,
      onOnBack: _cache[10] || (_cache[10] = ($event: any) => (state.getAggregateBusinessIdsHasRecommendOrderErrorModalState = false)),
      onOnNext: reRunFetchAggregateBusinessIdsHasRecommendOrder
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('推奨情報を持つ集計ID一覧取得に失敗しました')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"])
  ]))
}
}

})